/* eslint-disable import/no-extraneous-dependencies */
import React, { CSSProperties } from 'react';
import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  InputGroup,
  InputLeftElement,
  InputProps,
  InputRightElement,
} from '@chakra-ui/react';
import { UseFormRegister, FieldValues } from 'react-hook-form';
import _ from 'lodash';

interface InputFormProps extends InputProps {
  name: string | undefined | any;
  label: string | undefined;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  labelStyles?: CSSProperties;
  infoButton?: JSX.Element;
  isRequired?: boolean;
  placeholder?: string | undefined;
  register: UseFormRegister<FieldValues>;
  errors: any;
}

export const InputForm = ({
  name,
  label,
  iconLeft,
  iconRight,
  labelStyles,
  infoButton,
  isRequired = false,
  register,
  errors,
  ...rest
}: InputFormProps) => {
  return (
    <FormControl isRequired={isRequired} isInvalid={!!_.get(errors, name)} mb={5}>
      <Flex align="end">
        <FormLabel style={labelStyles} fontWeight="bold" mb={1} mr={3} htmlFor={name}>
          {label}
        </FormLabel>
        {infoButton}
      </Flex>
      <InputGroup alignItems="center" alignContent="center">
        {iconLeft && (
          <InputLeftElement pointerEvents="none" fontSize="1.2em">
            {iconLeft}
          </InputLeftElement>
        )}
        <Input
          id={name}
          boxShadow="0px 2px 4px #00000050"
          background="theme.light.bodyInput"
          _disabled={{ color: '#fffff' }}
          {...register(name)}
          {...rest}
        />
        {iconRight && (
          <InputRightElement pointerEvents="none" fontSize="1.2em">
            {iconRight}
          </InputRightElement>
        )}
      </InputGroup>
      {_.get(errors, name) && <FormErrorMessage>{_.get(errors, name)?.message}</FormErrorMessage>}
    </FormControl>
  );
};
